import { http } from "../client";
import { mapTimetableDetailObject, } from "../shared/program";
export var getTimetableRulesetDetail = function (id) {
    return http.api
        .get("timetable-programs/".concat(id))
        .then(function (response) { return response.data.data; })
        .then(mapTimetableDetailObject);
};
